import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { CommunityGroup } from './CommunityGroup'

const WrappedCommunityGroup = withLayout(LayoutType.Default, CommunityGroup)

export { WrappedCommunityGroup as CommunityGroup }
